<template>
  <div class="geo-searh-wrapper">
    <div class="wrapper">
      <div class="title">
        定位周边 <span class="fa fa-close" @click="closePanle()"></span>
      </div>
      <div class="content">
        <div class="filter">
          <div class="radius">
            <el-slider
              v-model="serchRadius"
              :step="1"
              show-stops
              :max="30"
              :min="1"
              :marks="sliderMarks"
            >
            </el-slider>
          </div>
          <div class="feature-type">
            <div
              class="feature"
              v-for="(item, index) in featureType"
              :key="index"
            >
              <el-checkbox v-model="item.checked">{{ item.lable }}</el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SearchResult
      :searchResult="searchResult"
      v-if="searchResult"
    ></SearchResult>
  </div>
</template>
<script>
import SearchResult from "./SearchResult.vue";
export default {
  name: "geoSearchManage",
  props: {
    closeAllPanel: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      searchResult: [],
      serchRadius: 10,
      sliderMarks: {
        1: "1Km",
        15: "15Km",
        30: "30Km",
      },
      featureType: [
        {
          lable: "宗教寺庙",
          value: "宗教寺庙",
          checked: true,
        },
        {
          lable: "民间民俗",
          value: "民间民俗",
          checked: false,
        },
        {
          lable: "红色历史",
          value: "红色历史",
          checked: false,
        },
        {
          lable: "生态山水",
          value: "生态山水",
          checked: false,
        },
        {
          lable: "古村古道",
          value: "古村古道",
          checked: false,
        },
        {
          lable: "特色物产",
          value: "特色物产",
          checked: false,
        },
        {
          lable: "文物资源(国家级)",
          value: "文物资源1",
          checked: false,
        },
        {
          lable: "文物资源(市级)",
          value: "文物资源2",
          checked: false,
        },
        {
          lable: "文物资源(区级)",
          value: "文物资源3",
          checked: false,
        },
      ],
      mapEventEmiterInited: false,
    };
  },
  watch: {
    serchRadius() {
      this.xxMap.setCircleSearchParam(this.serchRadius);
    },
  },
  computed: {},
  components: { SearchResult },
  methods: {
    closePanle() {
      this.$store.commit("setSearchResultFeatureIDs", {
        point_gids: null,
        line_gids: null,
        polygon_gids: null,
      });
      this.closeAllPanel();
      this.$store.commit("setSearchResultDialogType", 0);
    },
  },
  mounted() {
    if (this.mapEventEmiterInited) {
      return;
    }
    this.mapEventEmiterInited = true;

    this.xxMap.mapEventEmiter.$on("point-buffer", (extent) => {
      this.isMapPolySearching = true;
      let featureTyles = [];
      this.featureType.forEach((item) => {
        if (item.checked) {
          featureTyles.push(item.value);
        }
      });
      let data = {
        extent: extent,
        featureTyles: featureTyles.join(","),
      };
      this.$axios({
        url: "/api/gis_app/culture_search_by_polygon/",
        method: "post",
        data: data,
      }).then((res) => {
        let { status, data } = res.data;
        if (status === 200) {
          let pointData = data.point ? data.point : [];
          let lineData = data.line ? data.line : [];
          let polygonData = data.polygon ? data.polygon : [];

          let point_gids = [];
          pointData.forEach((item, index) => {
            item.index = index + 1;
            point_gids.push(item.gid);
          });

          let line_gids = [];
          lineData.forEach((item, index) => {
            item.index = index + 1;
            line_gids.push(item.gid);
          });

          let polygon_gids = [];
          polygonData.forEach((item, index) => {
            item.index = index + 1;
            polygon_gids.push(item.gid);
          });

          this.$store.commit("setSearchResultFeatureIDs", {
            point_gids: point_gids,
            line_gids: line_gids,
            polygon_gids: polygon_gids,
          });

          this.searchResult = [...pointData, ...lineData, ...polygonData];
          // this.$message("查询到：" + data.length + "条记录！");
        }
        this.isMapPolySearching = false;
      });
    });
  },
};
</script>
 
<style scoped lang="less" >
.geo-searh-wrapper {
  position: absolute;
  width: 500px;
  top: 0px;
  left: 45px;
  z-index: 99;
  background: #fff;
  border: solid 1px #ccc;
  padding: 10px;
  .wrapper {
    border: solid 1px #ccc;
    .title {
      background-color: #f3f8ff;
      height: 35px;
      line-height: 35px;
      padding-left: 10px;
      font-size: 15px;
      span:nth-child(1) {
        color: #355ba6;
        margin-right: 5px;
        font-weight: bold;
      }
      .fa-close {
        float: right;
        font-size: large;
        color: #9f9c9c;
        margin-top: 7px;
        margin-right: 10px;
      }
      .fa-close:hover {
        cursor: pointer;
        color: #706e6e;
      }
    }
    .content {
      padding: 10px;
      .filter {
        padding: 0 10px;
        .radius {
          height: 50px;
          margin-bottom: 10px;
        }
        .feature-type {
          margin-bottom: 10px;
          .feature {
            display: inline-block;
            width: 33.3%;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>

 